import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

const PHONE_DISPLAY = '077 492 95 25';
const PHONE_HREF = 'tel:0774929525';
const EMAIL = 'info@werklibuebe.ch';

interface ContactInfoProps {
  /** 'row' wraps horizontally (hero/footer); 'column' stacks (text pages). */
  direction?: 'row' | 'column';
  sx?: SxProps<Theme>;
}

/** Phone + e-mail contact block. Single source of truth reused across pages. */
const ContactInfo: React.FC<ContactInfoProps> = ({ direction = 'column', sx }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: direction === 'row' ? { xs: 'column', sm: 'row' } : 'column',
      flexWrap: 'wrap',
      columnGap: 3,
      rowGap: 0.5,
      color: 'common.white',
      ...sx,
    }}
  >
    <Typography variant="body1">
      Tel: <Link href={PHONE_HREF} color="primary">{PHONE_DISPLAY}</Link>
    </Typography>
    <Typography variant="body1">
      E-Mail: <Link href={`mailto:${EMAIL}`} color="primary">{EMAIL}</Link>
    </Typography>
  </Box>
);

export default ContactInfo;
